import React from "react";
import StatusBadge from "@/components/common/StatusBadge";

interface RequestDetailsCellProps {
  request?: {
    duration?: string;
    numberOfDays?: number;
    status?: string;
  } | null;
}

const RequestDetailsCell: React.FC<RequestDetailsCellProps> = ({ request }) => {
  if (!request) return <span className="text-slate-400">—</span>;
  const { duration, numberOfDays, status } = request;

  const mapDuration: Record<string, string> = {
    FULL_DAY: "Full Day",
    FIRST_HALF: "First Half",
    SECOND_HALF: "Second Half",
  };
  const displayDuration = mapDuration[duration || ""] || duration || "—";

  return (
    <div className="flex flex-col gap-1 min-w-35 text-xs py-1">
      <div className="text-slate-500 font-medium flex flex-wrap items-center gap-1">
        <span>{displayDuration}</span>
        <span className="text-[10px] bg-slate-100 text-slate-600 px-1 py-0.5 rounded-md font-normal">
          {numberOfDays} {numberOfDays === 1 ? "day" : "days"}
        </span>
      </div>
      <div className="mt-1">
        <StatusBadge status={status || "PENDING"} type="request" />
      </div>
    </div>
  );
};

export default RequestDetailsCell;
